import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface ActiveUntilTooltipProps {
  openLeft: boolean
  isInactive?: boolean
  isConsumedOrClosed?: boolean
  isBudget?: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
  isAccountClosed?: boolean
}

const ActiveUntilTooltip: React.FC<ActiveUntilTooltipProps> = (
  props,
): React.ReactElement => {
  const budgetText = (
    <Trns
      source={
        '${activeUntil} is the date this budget is set to expire. This date can be changed at any time and can be set to never expire.'
      }
      expressions={{
        activeUntil: (
          <span
            css={css`
              font-family: ${styleConstants.fontFamilies.medium};
            `}
          >
            <Trns source={'Active Until'} />
          </span>
        ),
      }}
    />
  )

  const virtualCardClosedText = (
    <Trns
      source={
        'This virtual card has been permanently closed and cannot be reactivated or updated'
      }
    />
  )
  const virtualCardInactiveText = (
    <Trns
      source={
        '${activeUntilHasPassed} Updating this date will reactivate the card.'
      }
      expressions={{
        activeUntilHasPassed: (
          <span
            css={css`
              font-family: ${styleConstants.fontFamilies.medium};
            `}
          >
            <Trns source={'Active Until date has passed.'} />
          </span>
        ),
      }}
    />
  )

  const virtualCardActiveUntilText = (
    <Trns
      source={
        "${activeUntil} is the date this card is set to deactivate. This date can be changed at anytime, but it's not to be confused with the Expiration Date you'll use when making payments."
      }
      expressions={{
        activeUntil: (
          <span
            css={css`
              font-family: ${styleConstants.fontFamilies.medium};
            `}
          >
            <Trns source={'Active Until'} />
          </span>
        ),
      }}
    />
  )

  const accountClosedSinceText = (
    <Trns
      source={
        'This Card Account has been permanently closed and cannot be reactivated or updated.'
      }
    />
  )

  const getTooltipText = (): React.ReactNode => {
    if (props.isAccountClosed) {
      return accountClosedSinceText
    } else if (props.isBudget) {
      return budgetText
    } else if (props.isConsumedOrClosed) {
      return virtualCardClosedText
    } else if (props.isInactive) {
      return virtualCardInactiveText
    } else {
      return virtualCardActiveUntilText
    }
  }

  const tooltipText = getTooltipText()
  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>{tooltipText}</p>
    </Tooltip>
  )
}

export default ActiveUntilTooltip
